<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="residence-container">
    <div class="banner-container">
      <img src="../../../assets/images/residence/banner2.jpg" />
    </div>
    <p class="section-title-line">
      <span>锦麟系</span>
    </p>
    <div class="section-container intro-box-content">
      <p>落址城市稀缺地段，</p>
      <p>耀世府邸，</p>
      <p>尽享尊荣。</p>
      <p>壮志人生，不拘一格，</p>
      <p>缔造艺术舒居。</p>
      <p>这才是新生代精英该有的房子，</p>
      <p>一座生长在城市的独家庭院。</p>
    </div>

    <div class="section-container">
      <div v-for="(item, index) in list" :key="item.name + index">
        <project-show :data="item"></project-show>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectShow from "@/components/projectShow";

export default {
  name: "JinLinXiPage",
  components: {
    ProjectShow,
  },
  data() {
    return {
      list: [
        {
          name: "新希望·锦麟府",
          title: "人文合院，成都院子",
          desc: [
            "住成都院子，过成都生活。",
            "新希望·锦麟府，",
            "宽院，窄巷，家春秋，",
            "再现成都理想院落人居。",
            "<br />",
            "* 落址“东进”战略桥头堡核心地段，紧邻三圣乡板块",
            "* 大型商业综合体环伺，离尘不离城的生活典范",
            "* 全龄化名校教育，为梦想插上翅膀",
            "* 拥揽稀缺生态资源，毗邻生态绿肺三圣花乡",
          ],
          footer: [
            "Tel：+86（28） 6728 9999",
            "Add：成都·龙泉驿经开区南一路与车城西四路交叉口",
          ],
          images: [
            require("../../../assets/images/residence/jl-1.png"),
            require("../../../assets/images/residence/jl-2.png"),
            require("../../../assets/images/residence/jl-3.png"),
            require("../../../assets/images/residence/jl-4.png"),
            require("../../../assets/images/residence/jl-5.png"),
          ],
        },
        {
          name: "新希望·锦麟河院",
          title: "城市山·浑河墅·国风合院",
          desc: [
            "院藏山河，墅悦锦麟。",
            "2018年，新希望·锦麟河院，",
            "璀璨亮相沈阳。",
            "唤醒沈城人的院落记忆，重现理想院落生活。",
            "<br />",
            "* 北靠棋盘山，南邻浑河鸟岛，万千风景一墅私藏",
            "* 两横两纵立体交通路网，无缝对接主城区",
            "* 8大商圈环伺，凝练成熟教育、医疗资源",
            "* 匠造“3进3院7景”，奢雅呈现现代东方园林景观",
          ],
          footer: ["Tel：+86（24）8667 5555", "Add：沈阳·浑南区·东陵东路86号"],
          images: [
            require("../../../assets/images/residence/hy-1.jpg"),
            require("../../../assets/images/residence/hy-2.jpg"),
            require("../../../assets/images/residence/hy-3.jpg"),
            require("../../../assets/images/residence/hy-4.jpg"),
            require("../../../assets/images/residence/hy-5.jpg"),
            require("../../../assets/images/residence/hy-6.jpg"),
            require("../../../assets/images/residence/hy-7.jpg"),
            require("../../../assets/images/residence/hy-8.png"),
          ],
        },
        {
          name: "新希望滨江·锦粼府",
          title: "时代奥体，谨此锦粼府",
          desc: [
            "新希望滨江·锦粼府",
            "据守市心板块核心区，",
            "约17万方城市洋房高层品质住区，",
            "致敬杭州拥江时代。",
            "<br />",
            "<br />",
            "* 三地铁接驳，两纵两横主干道畅达全城",
            "* 商业中心林立，繁华生活近在咫尺",
            "* 优质医疗资源，守护家人健康",
            "* 全龄教育优享，护航孩子成长每一步",
            "* 两轴四园规划，四大功能架空层泛会所",
          ],
          footer: [
            "Tel：+86（571）8215 6888",
            "Add：杭州萧山区·通惠北路与建设一路交汇处",
          ],
          images: [
            require("../../../assets/images/residence/jl-1.jpg"),
            require("../../../assets/images/residence/jl-2.jpg"),
            require("../../../assets/images/residence/jl-3.jpg"),
            require("../../../assets/images/residence/jl-4.jpg"),
            require("../../../assets/images/residence/jl-5.jpg"),
            require("../../../assets/images/residence/jl-6.jpg"),
            require("../../../assets/images/residence/jl-7.jpg"),
            require("../../../assets/images/residence/jl-8.jpg"),
            require("../../../assets/images/residence/jl-9.jpg"),
            require("../../../assets/images/residence/jl-10.jpg"),
          ],
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.residence-container {
}
</style>
